import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Brand } from '../Model/Dto/Brand/Brand';
import { BrandService } from '../Services/Brands/brand.service';
import { LoginService } from '../Services/login.service';
import { SystemService } from '../Services/system.service';
import { ProductDataSource } from '../Model/dataProcess/productDataSource';
import { DataSourcesService } from '../Services/DataProcess/datasources.service';
import { BeforeSendEvent } from 'devextreme/ui/file_uploader';
import { OAuthService } from 'angular-oauth2-oidc';
import { DxFileUploaderTypes } from 'devextreme-angular/ui/file-uploader';
import { RowRemovedEvent } from 'devextreme/ui/data_grid';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'brands',
  templateUrl: './brands.component.html',
  styleUrl: './brands.component.css'
})
export class BrandsComponent implements OnInit, AfterViewInit {
  brands: Brand[] = [];
  productDataSources: ProductDataSource[] = [];
  newOrUpdateBrand: Brand;
  isAddPopupVisible: boolean = false;
  addOrUpdateVisible = false;
  editMode = false;
  applyBrandChangesButtonHint = '';
  selectedRows: any;
  hasSelection: boolean;
  originalBrand: Brand;
  updatedBrands: { oldBrand: Brand; newBrand: Brand }[] = [];
  selectedMacroStartDate: Date;
  startMacroDialogVisible: boolean = false;

  constructor(
    public brandService: BrandService,
    public loginService: LoginService,
    public systemService: SystemService,
    public dataSourcesService: DataSourcesService,
    public oAuthService: OAuthService,
    public translate: TranslateService
  ) {
    this.addBrand = this.addBrand.bind(this);
    this.addOrUpdateBrand = this.addOrUpdateBrand.bind(this);
    this.applyBrandChanges = this.applyBrandChanges.bind(this);
  }

  ngOnInit() {
    this.newOrUpdateBrand = {} as Brand;
    this.reloadBrands();       
  }

  async ngAfterViewInit() {
    this.productDataSources = await this.dataSourcesService.getAll(this.loginService.currentCustomer.id);
  }

  onContentToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'addBrandTemplate',
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      locateInMenu: 'auto',
      template: 'applyBrandChangesButtonTemplate',
    });
  }

  async reloadBrands() {
    this.brands = await this.brandService.getBrands(this.loginService.currentCustomer.id);
  }

  deepCloneBrand(b: Brand): Brand {
    return new Brand(
      b.id,
      b.name,
      b.description,
      b.website,
      b.logoFile,
      b.dataSources ? [...b.dataSources] : undefined
    );
  }
  
  addOrUpdateBrand(brand?: Brand) {
    this.newOrUpdateBrand = {} as Brand;
    this.editMode = false;
    this.originalBrand = brand ? this.deepCloneBrand(brand) : {} as Brand;
    if (brand) {
      
      this.newOrUpdateBrand = brand;
      this.editMode = true;
    }
    this.addOrUpdateVisible = true;
  }

  addBrand(): void {
    if(this.originalBrand.name != this.newOrUpdateBrand.name) {
      
      this.updatedBrands.push({ oldBrand: this.originalBrand, newBrand: this.newOrUpdateBrand });
    }
    
    this.brandService.updateOrCreateBrand(this.newOrUpdateBrand, this.loginService.currentCustomer.id).then((result: Brand) => {
      if (this.editMode)
        this.systemService.notifyInfo("Marke wurde geändert");
      else {
        this.systemService.notifyInfo("Marke wurde angelegt");
      }
      this.reloadBrands();
    });

    this.addOrUpdateVisible = false;
  }

  onDataSourceSelectionChanged(e) {
    this.newOrUpdateBrand.dataSources = e.selectedRowKeys;
  }

  onBeforeSendUpload(event: BeforeSendEvent) {
    event.request.withCredentials = true;
    event.request.setRequestHeader('Authorization', 'Bearer ' + this.oAuthService.getAccessToken());
  }

  async onRowRemoved(event: RowRemovedEvent) {
    let key = event.key;
    await this.brandService.delete(key, this.loginService.currentCustomer.id);
    this.reloadBrands();
  }

  async onUploaded(e: DxFileUploaderTypes.UploadedEvent) {
    this.newOrUpdateBrand.logoFile = e.request.responseText as string;
    this.reloadBrands();
  }

  onSelectionChanged(e: any) {
    this.selectedRows = e.selectedRowsData;
    this.hasSelection = this.selectedRows.length;
    this.updatedBrands = [];

    this.selectedRows.forEach((row: Brand) => this.updatedBrands.push({ oldBrand: row, newBrand: row }));
  }
  
  applyBrandChangesButtonText() {
    var text = this.translate.instant('Alle Änderungen anwenden');
    this.applyBrandChangesButtonHint = this.translate.instant("Neue Marken oder Änderungen an Marken werden auf alle betroffenen Kataloge angewendet.");
    if (this.hasSelection) {
      text = this.translate.instant('Synchronisierung starten');
      this.applyBrandChangesButtonHint = this.translate.instant("Alle betroffenen Kataloge werden mit den ausgewählten Marken synchronisiert.");
    }
    return text;
  }
  
  
  isApplyBrandChangesButtonActiv() {
    return this.updatedBrands.length > 0 || this.hasSelection;
  }
  
  applyBrandChanges() {
    var oldToNewBrands = this.updatedBrands;
    this.brandService.applyBrandChanges({oldToNewBrands, scheduledFor: this.selectedMacroStartDate}, this.loginService.currentCustomer.id).then(() => {
      this.reloadBrands();
      this.updatedBrands = [];
    });
    this.startMacroDialogVisible = false;
  }
  
}
